import { APITransport } from '@client/transports/api';

export const AdsService = {
  getAll() {
    return APITransport.get({
      path: '/rest/domain/ads'
    });
  },
  async getById(id) {
    const response = await APITransport.get({
      path: '/rest/domain/ads'
    });

    return response.find(({ _id }) => _id === id);
  },
  async getClickReport(adid, timelimit) {
    return APITransport.get({
      path: '/rest/domain/report/clickdata',
      query: {
        aid: adid,
        days: timelimit
      }
    });
  },
  async getDeliveryReport(adid, timelimit) {
    return APITransport.get({
      path: '/rest/domain/report/deliverydata',
      query: {
        aid: adid,
        days: timelimit
      }
    });
  }
};
